import { Messages } from '../../../../codegen/Localize';
import { IDataAlertInfo } from '../../../../ts/models/IDataAlertInfo';
import { dataAlertRemoveMe } from '../../../actions/spaces/DataAlertMenuActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userIsSubscribedToAllAlerts } from './IEntityActionHelpers';

export const DataAlertRemoveMeAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.RemoveSelf,
  translateName: Messages.removeSelfFromAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[]) => {
    // only allow clicking is user is subscribed to all alerts
    return userIsSubscribedToAllAlerts(targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertRemoveMe(targetItems)
};
